import { useNavigate } from "react-router-dom";

function Contiueshopping() {
  let navigate = useNavigate();
  const reviewsHandler = () => {
     //navigate(-1);
    navigate('/checkout/pizza');
    };
  return(
   <div className="cont-shoping">
    <a className='button' onClick={reviewsHandler}>continue shopping</a>
  </div>);
} 

export default Contiueshopping;
